/**
 * 全局模块
 */
;(function(win) {
    /**
     * 全局 UpSDK 命名空间
     */
    var U = win.UpSDK = win.UpSDK || Object.assign({}, Uplib.Events);
    /**
     * 全局 Uplib 命名空间
     */
    var lib = win.Uplib = win.Uplib || {};
    /**
     * 浏览器系统语言
     */
    const SYSTEM_LANGUAGE = (function() {
        let systemLanguage = navigator.language || navigator.browserLanguage;

        let _systemLanguage = systemLanguage.toLowerCase();

        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            case 'ko':
                systemLanguage = 'ko-KR';
                break;
            default:
                break;
        }

        let arr = systemLanguage.split('-');

        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-US';
        }

        return systemLanguage;
    })();

    const cache = U.cache = new Uplib.Cache({
        prefix: 'uplive'
    });
    /**
     * 全局配置
     */
    U.config = {
        channel: 'sportlottery',
        language: SYSTEM_LANGUAGE,
        systemLanguage: SYSTEM_LANGUAGE,
    }

    U.setConfig = function(cfg) {
        U.config = Object.assign(U.config, cfg);
    }

    // 用户登录信息，有效期8小时
    U.writeLoginInfo = function(data) {
        cache.setCache('user', data, 8 * 3600 * 1000);
    }

    U.clearLoginInfo = function() {
        cache.removeCache('user');
    }
    /**
     * 判断登录
     */
    U.isLogin = function() {
        let user = cache.getCache('user');

        return !!(user && user.userToken);
    }
    /**
     * 获取用户登录信息
     */
    U.getUser = function(callback) {
        if (typeof callback == 'function') {
            U.onGetUserSuccess =  callback;
        }

        if (U.isLogin()) {
            let user = U.getUserInfo();

            U.onGetUserSuccess(user);
        } else {
            U.onGetUserSuccess();
        }
    }
    /**
     * 获取用户信息
     */
    U.getUserInfo = function() {
        return  cache.getCache('user') || {};
    },
    /**
     *  获取usertoken,uid
      {
        uid: '',
        userToken: '',
        subscribe: '',
        username: '',
        avatar: '',
        countryCode: '',
        gender: '',
        grade: '',
        upliveCode: ''
      }
     */
    U.getUserToken = function() {
        let user = cache.getCache('user');

        return user.userToken;
    }
    /**
     * 监听授权获取用户成功
     */
    U.on('getUserSuccess', function(data){
        U.onGetUserSuccess(data);
    });
})(window);


// WEBPACK FOOTER //
// ./src/js/openjs/uph5/global.js